import React from "react";

import appLogo from "../../../assets/weather-app-logo.webp";

import classes from "./WeatherCardHeaderContent.module.css";

import Card from "../Card";
import Image from "../Image";

function WeatherCardHeaderContent() {
  return (
    <Card WRAPPER="div" className={classes["header-flex-group"]}>
      <Image imgSrc={appLogo} altText="MyForecast weather app logo" />
      <h1>MyForecast</h1>
    </Card>
  );
}

export default React.memo(WeatherCardHeaderContent);
